import { render, staticRenderFns } from "./DeleteDomain.vue?vue&type=template&id=f71602be&scoped=true"
import script from "./DeleteDomain.vue?vue&type=script&lang=js"
export * from "./DeleteDomain.vue?vue&type=script&lang=js"
import style0 from "./DeleteDomain.vue?vue&type=style&index=0&id=f71602be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71602be",
  null
  
)

export default component.exports